import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TargetOrderStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperContainer: {
      width: "323px",
      height: "400px",
      position: "absolute" as "absolute",
      borderRadius: "10px",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      [theme.breakpoints.up("md")]: {
        left: "calc(100vw - 45%)",
      },
      [theme.breakpoints.down(420)]: {
        width: 350,
      },
    },
    insufficientBalanceText: { color: theme.palette.error.main },
    formGroupContainer: { width: "100%", display: "inline-flex" },
    tokenRowContainer: {
      width: "80%",
      position: "relative",
      alignSelf: "center",
      paddingTop: "20px",
    },
    zeroBalanceText: {
      color: theme.palette.secondary.main,
      fontSize: "14px",
      lineHeight: 1.21,
      flexGrow: 1,
      width: "80%",
      top: 49,
      paddingTop: "5px",
      alignSelf: "center",
      position: "absolute",
    },
    nextBtn: {
      marginTop: "20px",
      width: "100%",
      backgroundColor: theme.palette.secondary.main,
      color: "#fff",
      textTransform: "capitalize",
      "&:hover": { backgroundColor: "#fedbdb" },
      "&.Mui-disabled": {
        backgroundColor: "rgba(173, 192, 203, 0.3)",
        color: "#bdc2c5",
      },
    },

    nextBtnError: {
      marginTop: "5px",
      width: "100%",
      backgroundColor: theme.palette.secondary.main,
      color: "#fff",
      textTransform: "capitalize",
      "&:hover": { backgroundColor: "#fedbdb" },
      "&.Mui-disabled": {
        backgroundColor: "rgba(173, 192, 203, 0.3)",
        color: "#bdc2c5",
      },
    },
    successText: {
      textAlign: "center",
      fontSize: "14px",
      lineHeight: 1.21,
      color: "#002035",
    },

    filterSort: {
      height: "22px",
      minWidth: "100px",
      fontSize: "12px",
      borderRadius: "4px",
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: "#fff",
      color: theme.palette.primary.main,
      "& .MuiInputBase-input": { paddingLeft: "15px" },
      "& .MuiSelect-icon": { color: theme.palette.primary.main },
    },

    filterToken: {
      height: "22px",
      minWidth: "100px",
      fontSize: "12px",
      borderRadius: "4px",
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      "& .MuiInputBase-input": { paddingLeft: "15px" },
      "& .MuiSelect-icon": { color: theme.palette.primary.main },
      "&.Mui-disabled": {
        height: "22px",
        minWidth: "100px",
        fontSize: "12px",
        borderRadius: "4px",
        color: "#bdc2c5 !important",
        webkitTextFillColor: "#bdc2c5 !important",
        border: `1px solid #bdc2c5`,
      },
    },
    filter: {
      height: "22px",
      minWidth: "100px",
      fontSize: "12px",
      borderRadius: "4px",
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      paddingBottom: "0px",
      "& .MuiInputBase-input": { paddingLeft: "15px" },
      "& .css-6hp17o-MuiList-root-MuiMenu-list": {
        paddingBottom: "0px",
      },
      "& .MuiSelect-icon": { color: theme.palette.primary.main },
      [theme.breakpoints.down("sm")]: {
        width: "60px",
        minWidth: "60px",
      },
    },
    filterMenuItem: { fontSize: "12px" },
    filterSelected: {
      height: "22px",
      minWidth: "100px",
      fontSize: "12px",
      borderRadius: "4px",
      borderWidth: "2px",
      borderColor: "#324e61",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      padding: "0 15px 0 15px",
      "& .MuiSelect-icon": { color: "#fff" },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        minWidth: "60px",
        padding: "0px",
      },
    },
    filterDisabled: {
      height: "22px",
      minWidth: "100px",
      fontSize: "12px",
      borderRadius: "4px",
      color: "#bdc2c5 !important",
      border: `1px solid #bdc2c5`,
      "& .MuiSelect-icon": { color: "#bdc2c5" },
    },

    sortSelected: {
      height: "22px",
      minWidth: "100px",
      fontSize: "12px",
      borderRadius: "4px",
      borderWidth: "2px",
      borderColor: "#324e61",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      padding: "0 15px 0 15px",
      "& .MuiSelect-icon": { color: "#fff" },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        minWidth: "60px",
        padding: "0px",
      },
    },
    tooltipContainer: { maxWidth: "270px", alignSelf: "center" },
    availableTitle: {
      fontWeight: 600,
      fontSize: "14px",
      color: theme.palette.primary.main,
    },
    insufficientBalance: {
      fontSize: "14px",
      width: "80%",
      lineHeight: 1.21,
      color: `${theme.palette.secondary.main} !important`,
    },
    clearBtnContainer: {
      width: "100%",
      height: "25px",
      fontSize: "12px",
      cursor: "pointer",

      borderTop: `1px solid ${theme.palette.text.secondary}`,
    },
    clearBtn: {
      width: "100%",
      fontSize: "12px",
      height: "25px",
      textTransform: "capitalize",
      display: "flex",
      justifyContent: "center",
      fontWeight: 400,
    },
    insufficientBalanceLink: {
      fontWeight: 700,
      textDecoration: "underline",
      paddingLeft: "3px",
      paddingRight: "3px",
    },
    insufficientBalanceBold: {
      fontWeight: 700,
      paddingRight: "3px",
      paddingLeft: "3px",
    },
    projectionBox: {
      width: "80%",
      height: "184px",
      fontSize: "12px",
      backgroundColor: "#f0fef9",
      borderRadius: "10px",
      margin: "24px 24px 0 24px",
      padding: "16px",
    },
    projectionBoxRange: {
      backgroundColor: "#fef2f2",
      border: "solid 0.5px #ef4444",
    },
    projectionBoxCloseToMarket: {
      backgroundColor: "#f5f3ef",
      border: "solid 0.5px #ccc3ae",
    },
    availableSelected: { color: theme.palette.mode === "light" ? "#BDC2C5" : "#788187" },
    title: {
      paddingLeft: "25px",
      fontSize: "16px",
      letterSpacing: " -0.32px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    closeContainer: {
      padding: "20px",
    },
    summaryTextTitle: {
      position: "relative",
      flex: 1,
      fontSize: "14px",
      fontWeight: 600,
      paddingBottom: "16px",
    },
    list: {
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&::-webkit-scrollbar-track": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        "-webkit-border-radius": "10px",
        borderRadius: "10px",
        background: "#eaeaea",
      },
      width: "100%",
      marginTop: "24px",
      height: "250px",
      maxWidth: 420,
      bgcolor: "background.paper",
      overflowY: "scroll",
    },
    headerContainer: {
      height: "143px",
      padding: "10px",
      borderTopLeftRadius: "26px",
      borderTopRightRadius: "26px",
      // transition: "all 1s ease-out",
      color: "#fff",
      backgroundColor: theme.palette.primary.main,
    },
    exampleImg: {
      display: "flex",
      justifyContent: "center",
      flexGrow: 1,
    },
    loaderContainer: { position: "relative" },
    formContainer: {
      alignSelf: "center",
      paddingTop: "16px",
      paddingBottom: "12px",
      width: "80%",
    },

    formContainerError: {
      alignSelf: "center",
      paddingTop: "5px",
      paddingBottom: "12px",
      width: "80%",
    },
    clearIcon: { height: "12px", alignSelf: "center", width: "12px" },
    formSubHeading: {
      fontWeight: 600,
      fontSize: "14px",
      textAlign: "end",
    },

    currencyInput: {
      height: "33px",
      borderRadius: "10px",
      width: "160px",
      paddingBottom: " 20px",
      backgroundColor: "#F8F9F9",

      "& .css-70g275-MuiInputBase-input-MuiInput-input": {
        textAlign: "end",
      },
    },
    dropDownBuySell: {
      height: "33px",
      width: "70px",
      textAlign: "end",
      textTransform: "capitalize",
      fontWeight: 600,
      borderRadius: "10px",
      fontSize: "14px",
      color: "#fff",
      "&:hover": { backgroundColor: "#4e7086", border: "#4e7086" },
      backgroundColor: theme.palette.primary.main,
      "& .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
        color: "#fff",
      },
      "& .css-bpeome-MuiSvgIcon-root-MuiSelect-icon": {
        color: "#fff",
      },
    },
    tokenInput: {
      marginRight: "5px",
      textAlign: "end",
      height: "33px",
      width: "201px",
      borderRadius: "10px",
      backgroundColor: theme.palette.primary.contrastText,
      "& .MuiFilledInput-input": {
        padding: "0 0 0 10px",
        textAlign: "end",
      },
    },
    img: { width: "270px", height: "88px" },
    toolTipNumber: {
      color: theme.palette.secondary.main,
      fontSize: "10px",
    },
    toolTipListText: { color: "#FFF", fontSize: "12px" },
    formProgressBar: {
      marginTop: "12px",
      marginBottom: "12px",
      height: "20px",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "6px",

      "& .MuiLinearProgress-barColorPrimary": {
        backgroundColor: "#0BEC9F",
      },
    },
    completionText: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#BDC2C5",
      transition: "color 1s ease",
    },
    completionTextCompleted: { color: theme.palette.primary.main },
    tableRow: {
      textTransform: "capitalize",
      fontSize: "14px",
      fontWeight: 700,
      background: theme.palette.background.paper,
      paddingBottom: "36px",
    },
    tableColumnContent: {
      textTransform: "capitalize",
    },
    tableColumnHeading: { display: "inline-flex" },
  }),
);
